import {gql} from 'apollo-angular';
import {StatusFragment} from "../queries/fragments/Status";

export const ADD_NEW_CLASS = gql`
  mutation AddSchoolClass($formData: InSchoolClass!) {
    addSchoolClass(data: $formData) {
      type,
      message
    }
  }
`;
